import { AnyAction } from '@reduxjs/toolkit';
import { CreateCustomerRoutine } from '../redux-routines';
import type { ICustomerCreationState } from '../interfaces';

export const initialState: ICustomerCreationState = {
  isLoading: false,
  error: null,
};

export const customerCreationReducer = (
  state: ICustomerCreationState = initialState,
  action: AnyAction,
): ICustomerCreationState => {
  switch (action.type) {
    case CreateCustomerRoutine.SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case CreateCustomerRoutine.REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case CreateCustomerRoutine.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: CreateCustomerRoutine.getFailurePayload(action),
      };

    default:
      return state;
  }
};
